<template>
<div class="mt-5">
  <Calendar></Calendar>
</div>
</template>

<script>
import {
  checkAccess
} from "@/scripts/groupFuncs";
import Calendar from "@/components/Calendar/Calendar";

export default {
  name: "CalendarPage",
  components: {
    Calendar
  }
};
</script>



// WEBPACK FOOTER //
// src/views/CalendarPage.vue